// src/components/DrumPlayer.js
import React, { useEffect, useState } from 'react';
import * as Tone from 'tone';

const DrumPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const kick = new Tone.Player('/drums/kick.wav').toDestination();
  const snare = new Tone.Player('/drums/snare.wav').toDestination();
  const hihat = new Tone.Player('/drums/hihat.wav').toDestination();

  useEffect(() => {
    if (isPlaying) {
      Tone.Transport.scheduleRepeat((time) => {
        kick.start(time);
        snare.start(time + 0.5);
        hihat.start(time + 0.25);
        hihat.start(time + 0.75);
      }, '1n');
      Tone.Transport.start();
    } else {
      Tone.Transport.stop();
      Tone.Transport.cancel();
    }
  }, [isPlaying]);

  return (
    <button onClick={() => setIsPlaying(!isPlaying)}>
      {isPlaying ? '🛑 Stop Drums' : '🥁 Start Drums'}
    </button>
  );
};

export default DrumPlayer;
